import React from 'react'


  let product = [
    {
      id: 1,
      name: "acer",
      price: 20000,
      category: 'Laptop',
      img: "https://images.unsplash.com/photo-1525971977907-20d22da82d6f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fGxhcHRvcHMlMjBhY2VyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
    },
    {
      id: 2,
      name: "Lenovo",
      price: 60000,
      category: 'Laptop',
      img: "https://images.unsplash.com/photo-1496181133206-80ce9b88a853?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bGFwdG9wfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
    },
    {
      id: 3,
      name: "HP",
      price: 134500,
      category: 'Laptop',
      img: "https://img.freepik.com/free-psd/laptop-mock-up-isolated_1310-1458.jpg?size=626&ext=jpg",
    },
    {
      id: 4,
      name: "Mac Book",
      price: 200003,
      category: 'Laptop',
      img: "https://img.freepik.com/free-psd/laptop-mock-up-isolated_1310-1458.jpg?size=626&ext=jpg",
    },
    {
      id: 5,
      name: "Asus",
      price: 50000,
      category: 'Laptop',
      img: "https://img.freepik.com/free-psd/laptop-mock-up-isolated_1310-1458.jpg?size=626&ext=jpg",
    },
    {
      id: 6,
      name: "Dell",
      price: 23340,
      category: 'Laptop',
      img: "https://img.freepik.com/free-psd/laptop-mock-up-isolated_1310-1458.jpg?size=626&ext=jpg",
    },
    {
      id: 7,
      name: "Microsoft",
      price: 23532,
      category: 'Laptop',
      img: "https://img.freepik.com/free-psd/laptop-mock-up-isolated_1310-1458.jpg?size=626&ext=jpg",
    },
    {
      id: 8,
      name: "Huawei",
      price: 90000,
      category: 'Laptop',
      img: "https://img.freepik.com/free-psd/laptop-mock-up-isolated_1310-1458.jpg?size=626&ext=jpg",
    },
    {
      id: 9,
      name: "Samsung",
      price: 110000,
      category: 'Laptop',
      img: "https://img.freepik.com/free-psd/laptop-mock-up-isolated_1310-1458.jpg?size=626&ext=jpg",
    },
    {
      id: 10,
      name: "Toshiba",
      price: 30890,
      category: 'Laptop',
      img: "https://img.freepik.com/free-psd/laptop-mock-up-isolated_1310-1458.jpg?size=626&ext=jpg",
    },
    {
      id: 11,
      name: "LG",
      price: 92893,
      category: 'Laptop',
      img: "https://img.freepik.com/free-psd/laptop-mock-up-isolated_1310-1458.jpg?size=626&ext=jpg",
    },
    {
      id: 12,
      name: "Lava",
      price: 190999,
      category: 'Laptop',
      img: "https://img.freepik.com/free-psd/laptop-mock-up-isolated_1310-1458.jpg?size=626&ext=jpg",
    },
    {
      id: 13,
      name: "Nokia",
      price: 40000,
      category: 'Laptop',
      img: "https://img.freepik.com/free-psd/laptop-mock-up-isolated_1310-1458.jpg?size=626&ext=jpg",
    },
    {
      id: 14,
      name: "Ns200",
      price: 400000,
      category: 'Bike',
      img: "https://images.unsplash.com/photo-1591378603223-e15b45a81640?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8a3RtJTIwZHVrZSUyMDIwMHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=1000&q=60",
    },
    {
      id: 15,
      name: "Duke200",
      price: 400000,
      category: 'Bike',
      img: "https://images.unsplash.com/photo-1591378603223-e15b45a81640?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8a3RtJTIwZHVrZSUyMDIwMHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=1000&q=60",
    },
    {
      id: 16,
      name: "MT-15",
      price: 400000,
      category: 'Bike',
      img: "https://images.unsplash.com/photo-1591378603223-e15b45a81640?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8a3RtJTIwZHVrZSUyMDIwMHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=1000&q=60",
    },
    {
      id: 17,
      name: "Gixer150",
      price: 400000,
      category: 'Bike',
      img: "https://images.unsplash.com/photo-1591378603223-e15b45a81640?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8a3RtJTIwZHVrZSUyMDIwMHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=1000&q=60",
    },
    {
      id: 18,
      name: "X-Pulse",
      price: 400000,
      category: 'Bike',
      img: "https://images.unsplash.com/photo-1591378603223-e15b45a81640?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8a3RtJTIwZHVrZSUyMDIwMHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=1000&q=60",
    }
  ];
  


export default product